import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useSmartClosePopups, LAYER } from 'js/components/common/PopupManager';
import { closePopupsAction } from 'js/components/common/PopupManager/store/actions';
import { showTermsConditionsConfirmationPopupAction } from 'js/components/popups/TermsConditionsConfirmationPopup';

import * as pas from '../../../pas';
import { VALIDATION_TYPE } from '../constants';

export const useValidateTCVersion = () => {
    const dispatch = useDispatch();
    const closePopups = useSmartClosePopups();

    return useCallback((pasLoginResponse) => new Promise((resolve, reject) => {
        const { sessionValidationData = {} } = pasLoginResponse?.data || {};

        if (!sessionValidationData.SessionValidationByTCVersionData) {
            resolve();

            return;
        }

        let isValid = false;
        const { tcVersionUrl, termVersionReference } = sessionValidationData.SessionValidationByTCVersionData[0] || {};
        const tcVersionUrlObject = new URL(tcVersionUrl);
        const tcVersion = tcVersionUrlObject.searchParams.get('version');

        dispatch(showTermsConditionsConfirmationPopupAction({
            tcVersion,
            closeAll: false,
            layer: LAYER.SESSION_VALIDATION,
            onAccept: async () => {
                try {
                    await pas.setTerms({ accept: true, termVersionReference });

                    isValid = true;
                    dispatch(closePopupsAction({ popups: [VALIDATION_TYPE.ACCEPT_TERMS] }));
                    resolve();
                } catch (error) {
                    reject(error);
                }
            },
            onDecline: () => {
                if (!isValid) {
                    closePopups({ excludeLayers: [LAYER.LOGIN] });
                    reject(pasLoginResponse);
                }
            }
        }));
    }), [dispatch, closePopups]);
};
